module.exports = {"client":{"newClient":["Add a new client","צור לקוח חדש"],"searchByName":["Search client by name","חפש לקוח לפי שם"],"tax":["Tax Number","ח.פ."]}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/client.json
// module id = 440
// module chunks = 0